import { render, staticRenderFns } from "./speaking.vue?vue&type=template&id=da0de6fe&scoped=true"
import script from "./speaking.vue?vue&type=script&lang=js"
export * from "./speaking.vue?vue&type=script&lang=js"
import style0 from "./speaking.vue?vue&type=style&index=0&id=da0de6fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0de6fe",
  null
  
)

export default component.exports